import { gql } from '@apollo/client';

import { PracticeSession } from '../../types';
import { PracticeSessionFragment } from '../fragments';

export interface CreatePracticeSessionMutationVariables {
  courseId: string;
  input: {
    name: string;
    exercises: string[];
  };
}

export interface CreatePracticeSessionMutationResult {
  practiceSession: PracticeSession;
}

export const createPracticeSessionMutation = gql`
  mutation CreatePracticeSessionMutation($courseId: String!, $input: CreatePracticeSessionMutationInput!) {
    practiceSession(courseId: $courseId, input: $input) @rest(type: "PracticeSession", path: "courses/{args.courseId}/practice", method: "POST") {
      ...PracticeSession
    }
  }
  ${PracticeSessionFragment}
`;
